// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"9edcb704","636":"cc00fa56"}[chunkId] + ".chunk.css";
};